module.exports = __webpack_public_path__ + "static/media/printer_icon.fd2f8b08.svg";